<!--
 * @Author: 仙道
 * @Date: 2022-06-18 16:44:24
 * @LastEditTime: 2022-10-28 00:09:00
 * @email: hao.li08@weimob.com
 * @Description:
 * @FilePath: /iplus-iwt-fe/src/components/jeecgbiz/JSelectDefStandard.vue
-->
<template>
  <j-select-biz-component :customSelectColumn="handleColumn" :width="1170" returnId v-bind="configs" v-on="$listeners" />
</template>

<script>
  import JSelectBizComponent from './JSelectBizComponent'

  export default {
    name: 'JSelectDefStandard',
    components: { JSelectBizComponent },
    props: ['value', 'defType', 'devClassCode'],
    data () {
      return {
        settings: {
          name: '缺陷标准',
          displayKey: 'defPart',
          valueKey: 'id',
          returnKeys: ['id', 'defPart'],
          notExist: 'true',
          queryParamCode: 'defPart',
          queryParamText: '缺陷部位',
          ellipsisLength: -1,

          columns: [{
            title: '缺陷部位',
            align: 'center',
            dataIndex: 'defPart',
            selectTitle: '缺陷信息'
          },
          {
            title: '缺陷类别',
            align: 'center',
            dataIndex: 'defCategory'
          },
          {
            title: '缺陷描述',
            align: 'center',
            width: '35%',
            widthRight: '70%',
            dataIndex: 'remarks'
          },
          {
            title: '缺陷等级',
            align: 'center',
            dataIndex: 'defLevel_dictText'
          },
          ],

        }
      }
    },
    computed: {
      configs () {
        this.listUrl = `/device/defStandard/list?defType=${this.defType}&devClassCode=${this.devClassCode}*`;

        return { value: this.value, listUrl: this.listUrl, ...this.settings, ...this.$attrs }
      }
    },
    methods: {
      handleColumn: (text, record) => {
        return record.defPart + '-' + record.defCategory + '-' + record.remarks + '-' + record.defLevel_dictText
      }

    }
  }
</script>

<style lang="less" scoped></style>